import React from 'react';
import InfoModal from '../../components/common/InfoModal';

export default function SupplierInfoModal({ supplier, isOpen, onClose }) {
  if (!supplier) return null;

  // Safely flatten address fields
  const { street, city, state, zip } = supplier.address || {};

  console.log('Supplier info for modal:', supplier);

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={onClose}
      title="Supplier Info"
    >
      <div className="space-y-3">
        <p>
          <strong>Name:</strong>{' '}
          {supplier.name || <span className="text-gray-400">N/A</span>}
        </p>

        <p>
          <strong>Email:</strong>{' '}
          {supplier.email || <span className="text-gray-400">N/A</span>}
        </p>

        <p>
          <strong>Phone:</strong>{' '}
          {supplier.phone || <span className="text-gray-400">N/A</span>}
        </p>

        <div>
          <strong>Address:</strong>
          <div className="mt-1">
            {street && <div>{street}</div>}
            {(city || state || zip) && (
              <div>{[city, state, zip].filter(Boolean).join(', ')}</div>
            )}
            {!street && !city && !state && !zip && (
              <span className="text-gray-400">No address available</span>
            )}
          </div>
        </div>
      </div>
    </InfoModal>
  );
}
